import { useAppSelector } from '@/shared/store/hooks';
import { isTeamMemberRole } from '@/shared/config/roles';

/** True when the signed-in user is an Ad Agency team member. */
export function useIsTeamMember(): boolean {
  const role = useAppSelector((s) => s.auth.user?.role);
  return isTeamMemberRole(role);
}
